import React from "react";
import PropTypes from "prop-types";
import FavoriteCardItem from "./card-item";
import AlertCardItem from "./AlertCardItem";
import SeeAllBtn from "../see-all-btn";
import { Link } from "react-router-dom";

const FavoritesCard = ({ loggedIn, type, seeAll, seeAllVisible, posts = [] }) => (
  <div className="favoriteCard">
    <div className="card-header">
      <span className="title">
        {type === "posts" && "Posts"}
        {type === "alerts" && "Alerts"}
      </span>
      {seeAllVisible && <SeeAllBtn link={seeAll} />}
    </div>
    <div className="card-body">
      {loggedIn && type === "alerts" && (
        <React.Fragment>
          <br />
          <br />
          <div className="alerts-premium">
            Alerts are available only to registered members. Please check prices
            below.
          </div>
          <Link to={"/prices"} className="alerts-premium-linear">
            Become A Member
          </Link>
        </React.Fragment>
      )}
      {type === "posts" &&
        posts.map((post) => (
          <FavoriteCardItem loggedIn={loggedIn} type={type} post={post} />
        ))}
      {type === "alerts" &&
        posts
          .filter((p) => p.content !== undefined)
          .map((post) => <AlertCardItem type={type} post={post} />)}
      {type === "alerts" &&
        posts.filter((p) => p.content !== undefined).length == 0 &&
        posts.length > 0 && (
          <React.Fragment>
            <br />
            <br />
            <div className="alerts-premium">
              Please renew your membership to be able to continue receiving
              alerts.
            </div>
            <Link to={"/user-profile"} className="alerts-premium-linear">
              My Billing Area
            </Link>
          </React.Fragment>
        )}
    </div>
  </div>
);

FavoritesCard.propTypes = {
  type: PropTypes.string.isRequired,
};

export default FavoritesCard;
